import {withExperiments} from '@wix/yoshi-flow-editor'
import {ReservationTimer as ReservationTimerComponent} from './reservation-timer'

export const ReservationTimer = withExperiments(ReservationTimerComponent)
